import { render, staticRenderFns } from "./providers.vue?vue&type=template&id=2561e65b&scoped=true&"
import script from "./providers.vue?vue&type=script&lang=ts&"
export * from "./providers.vue?vue&type=script&lang=ts&"
import style1 from "./providers.vue?vue&type=style&index=1&id=2561e65b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2561e65b",
  null
  
)

export default component.exports